<template>
  <div class="parte-card">
    <!-- HEADER -->
    <div class="card-header card-header-icon">
      <div class="card-icon parte-card-header" @click="clickTicket">
        <h4 class="card-title text-white">
          Folio: {{ parte.folio }} ({{ tipo_parte }})
        </h4>
        
      </div>
      <a v-if="parte.zarpe" @click="clickDelete" class="delete-btn" title="Eliminar">
                  <i class="material-icons">delete</i>
                </a>
    </div>

    <!-- BODY -->
    <div class="card-body parte-card-body">
      <div class="parte-table-container">
        <table class="parte-table">
          <tbody>
            <tr v-if="parte.wellboat">
              <td>Wellboat</td>
              <td>{{ parte.wellboat.nombre }}</td>
            </tr>
            <tr v-if="parte.tipo_origen">
              <td>Punto de origen</td>
              <td>{{ parte.tipo_origen.nombre }}</td>
            </tr>
            <tr v-if="parte.empresa">
              <td>Cliente</td>
              <td>{{ parte.empresa.razon_social }}</td>
            </tr>
            <tr v-if="parte.origen">
              <td>Origen</td>
              <td>{{ parte.origen.nombre }}</td>
            </tr>
            <tr v-if="parte.destino">
              <td>Destino</td>
              <td>{{ parte.destino.nombre }}</td>
            </tr>
            <tr v-if="parte.zarpe">
              <td>Zarpe</td>
              <td>{{ moment(parte.zarpe).format('DD-MM-YYYY HH:mm') }}</td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* CARD BASE */
.parte-card {
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 12px;
  transition: transform 0.2s ease, box-shadow 0.3s ease;
  box-shadow: 0px 4px 15px rgba(0, 0, 50, 0.3);
  max-width: 450px;
  position: relative; /* necesario para posicionar delete */
}
.parte-card:hover {
  transform: translateY(-3px);
  box-shadow: 0px 8px 20px rgba(0, 0, 50, 0.45);
}

/* HEADER */
.parte-card-header {
  background: linear-gradient(135deg, #0d1f45, #337fd9);
  padding: 10px 14px;
  border-radius: 6px 6px 0 0;
  cursor: pointer;
  text-align: left;
  position: relative; /* para botón delete */
}
.parte-card-header .card-title {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 1.5; /* alinea con los td de la tabla */
}

/* BOTÓN ELIMINAR */
.delete-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  color: #e53935 !important;
  font-size: 20px;
  cursor: pointer;
  transition: color 0.2s ease;
}
.delete-btn:hover {
  color: #b71c1c !important;
}

/* BODY */
.parte-card-body {
  padding: 10px 14px; /* mismo padding que el header para alinear texto */
}

/* TABLE */
.parte-table-container {
  width: 100%;
  overflow-x: auto;
}
.parte-table {
  width: 100%;
  border-collapse: collapse;
}
.parte-table td {
  padding: 6px 0; /* solo vertical, horizontal ya lo da el padding del body */
  font-size: 14px;
  border-bottom: 1px solid #eaeaea;
  text-align: left;
}
.parte-table tr:last-child td {
  border-bottom: none;
}
.parte-table td:first-child {
  font-weight: bold;
  color: #444;
  width: 35%;
}

</style>

<script>
export default {
  props: ['parte'],
  data: () => ({
    tipo_partes: [
      { id: 1, nombre: 'Cosecha' },
      { id: 2, nombre: 'Interno' },
      { id: 3, nombre: 'Smolt' },
      { id: 4, nombre: 'Mortalidad' },
      //{ id: 5, nombre: 'Baño' },
      { id: 5, nombre: 'Manejo' },
      { id: 6, nombre: 'Vacuna' },
      { id: 7, nombre: 'Muestreo' }
    ]
  }),
  methods: {
    clickTicket() {
      this.$emit('clicked', this.parte);
    },
    clickDelete() {
      this.$emit('deleted', this.parte);
    }
  },
  computed: {
    tipo_parte() {
      const tp = this.tipo_partes.find(tp => tp.id == this.parte.tipopartes_id);
      return tp ? tp.nombre : '';
    }
  }
};
</script>
